export default __webpack_public_path__ + "static/media/dapplion.e92e6fe7.png";